'use strict';

const trapFocus = require('../utilities/focusTrap').trapFocus;
const screenUtils = require('../utilities/screen');

class DialogComponent {
    constructor(dialog, settings) {
        this.state = {
            open: false,
            initialized: false
        };

        this.elements = {
            $document: $(document)
        };

        this.selectors = {
            dialog: '.js-dialog',
            content: '.js-dialog-content'
        };

        this.modifiers = {
            opened: '[open]'
        };

        const id = dialog.id;
        const finalSettings = { id, dialog, ...settings };
        const $dialog = $(dialog);
        const $content = $dialog.find(this.selectors.content);

        Object.assign(this.elements, {
            dialog,
            $dialog,
            $content
        });

        Object.assign(this.selectors, {
            id,
            openDialog: `[data-open-dialog="${id}"]`,
            closeDialog: `[data-close-dialog="${id}"]`
        });

        this.init(finalSettings);
    }

    init(settings) {
        const defaultOptions = {
            open: false,
            interruptClosing: null
        };

        this.options = {
            ...(this.options || defaultOptions),
            ...this.elements.$dialog.data(),
            ...settings
        };

        this.initEvents();
        this.initOptions();

        this.state.initialized = true;
    }

    reInit(settings) {
        this.destroy();
        this.init(settings);
    }

    initEvents() {
        if (this.state.initialized) {
            return;
        }
    }

    initOptions() {
        const { open } = this.options;

        if (open && !this.state.open) {
            this.handleClickOpenDialogButton();
        } else if (open === false && this.state.open && !this.options.interruptClosing) {
            this.destroy();
        }
    }

    handleClickOpenDialogButton() {
        screenUtils.lockScroll(true);
        this.elements.$dialog.trigger('dialog:before-open');
        this.elements.dialog.showModal();
        this.elements.$dialog.trigger('dialog:open', {
            options: this.options
        });

        this.state.open = true;

        this.initDialogEvents();
    }

    initDialogEvents() {
        this.focusTrap = trapFocus(this.elements.dialog);
        this.elements.$dialog.on(`keydown.dialog-${this.selectors.id}`, (e) => this.handleKeydownDialog(e));
        this.elements.$document.on(`click.dialog-${this.selectors.id}`, this.selectors.closeDialog, (e) =>
            this.handleClickCloseDialogButton(e)
        );
    }

    handleKeydownDialog(e) {
        if (e.key !== 'Escape') {
            return;
        }

        e.preventDefault();

        this.handleClickCloseDialogButton(e);
    }

    handleClickCloseDialogButton(e) {
        e.stopPropagation();

        if (!this.isCloseButton(e)) {
            return;
        }

        if (this.options.interruptClosing) {
            this.options.interruptClosing(this, e);

            return;
        }

        this.destroy();
    }

    isCloseButton({ target, type, currentTarget }) {
        return currentTarget === target || type !== 'click';
    }

    destroy() {
        this.destroyDialogEvents();
        this.elements.$dialog.trigger('dialog:start-closing');
        this.handleCloseDialog();
    }

    destroyDialogEvents() {
        screenUtils.unlockScroll();
        this.focusTrap = null;
        this.interruptClosing = null;
        this.elements.$dialog.off(`keydown.dialog-${this.selectors.id}`);
        this.elements.$document.off(`click.dialog-${this.selectors.id}`);
    }

    handleCloseDialog() {
        this.elements.dialog.close();
        this.focusOpenDialogButton();
        this.elements.$dialog.trigger('dialog:close');
        this.state.open = false;
    }

    focusOpenDialogButton() {
        const openDialogButton = document.querySelector(this.selectors.openDialog);

        if (!openDialogButton) {
            return;
        }

        openDialogButton.focus();
    }
}

module.exports = DialogComponent;